"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withDynamicTranslation = void 0;
const withDynamicTranslation = (text, props) => {
    let updatedText = text;
    for (const [name, value] of Object.entries(props)) {
        const regex = new RegExp(`:${name}`, 'g');
        updatedText = updatedText === null || updatedText === void 0 ? void 0 : updatedText.replace(regex, value);
    }
    return updatedText;
};
exports.withDynamicTranslation = withDynamicTranslation;
